module.exports = __webpack_public_path__ + "static/media/checkers.b8ba2392.svg";